import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import axios from "axios";

import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import ModuleView from "@/pages/ModuleView";
import QuizView from "@/pages/QuizView";
import AdminPanel from "@/pages/AdminPanel";
import CertificatePage from "@/pages/CertificatePage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Axios interceptor for auth
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    toast.success("Déconnexion réussie");
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-orange-50 via-purple-50 to-cream-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={!user ? <AuthPage onLogin={login} /> : <Navigate to="/dashboard" />}
          />
          <Route
            path="/dashboard"
            element={user ? <Dashboard user={user} onLogout={logout} /> : <Navigate to="/" />}
          />
          <Route
            path="/module/:id"
            element={user ? <ModuleView user={user} onLogout={logout} /> : <Navigate to="/" />}
          />
          <Route
            path="/module/:id/quiz"
            element={user ? <QuizView user={user} onLogout={logout} /> : <Navigate to="/" />}
          />
          <Route
            path="/certificate"
            element={user ? <CertificatePage user={user} onLogout={logout} /> : <Navigate to="/" />}
          />
          <Route
            path="/admin"
            element={user?.role === "admin" ? <AdminPanel user={user} onLogout={logout} /> : <Navigate to="/dashboard" />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
